<template lang="html">
  <div class="layout-public">

    <div class="header-public">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <router-link to="/log-in" class="logo">
              <img src="../assets/img/logo-smiley.svg" alt="smiley" width="94px" height="30px">
            </router-link>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div> <!-- /.header-public -->

    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12 offset-sm-0">

          <hr />
          <slot></slot>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </div> <!-- /.container -->

  </div> <!-- /.layout-public -->
</template>

<script>
export default {
  props: ['practiceName'],
  methods: {

  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.header-public {
  background-color: @color-blue;
  padding: 35px 0;
  margin-bottom: 50px;
}

</style>
